import { useSelector } from "react-redux";

import { selectAuth } from "@redux";
import { ComponentSurveyDetail } from "@components";

export const PageSurveyDetail = () => {
    //redux states
    const { userInfo } = useSelector(selectAuth);

    //variable
    const memberTier = userInfo?.memberTier;

    return (
        <ComponentSurveyDetail
            memberTier={memberTier} avatar={""} fullName={""} />
    );
};
